import { BaseDialogComponent } from './../../../../../components/kit/base-dialog/base-dialog.component';
import { FolderNoteCreateInput } from '../../../../../../../../types/src/services/input-type/folder/folder-note.input';
import { Component, OnInit, output, viewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { isInvalid } from '../../../../shared/helpers/validate';
import { fb } from '../../../../shared/shared.global-service';
import { FolderNotesComponentStore } from './person-notes-dialog.store';
import { InputWysiwygComponent } from '../../../../shared/components/inputs/input-wysiwyg/input-wysiwyg.component';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-person-notes-dialog',
    templateUrl: './person-notes-dialog.component.html',
    styleUrls: ['./person-notes-dialog.component.scss'],
    providers: [FolderNotesComponentStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputWysiwygComponent,
        ReactiveFormsModule,
    ],
})
export class FolderNotesDialogComponent extends BaseDialogComponent implements OnInit {

    public readonly store = inject(FolderNotesComponentStore);

    public readonly wysiwyg = viewChild<InputWysiwygComponent>(InputWysiwygComponent);
    
    public note: any | null = null;
    public folderId: number | null = null;

    public created = output<string>();

    protected form = fb.group({
        note: fb.control<string>(''),
    });

    public ngOnInit(): void {
        this.note = this.dialogConfig.data?.note;
        this.folderId = this.dialogConfig.data?.folderId;
        if (this.note) {
            this.form.patchValue({
                note: this.note.note || '',
            });
        }
    }

    public override async save(): Promise<void> {
        // here would be edit called
        await this.savePersonNote();
    }

    public async savePersonNote(): Promise<void> {
        if (!this.store.isAllowed('folderNote.create')()) return;
        if (isInvalid(this.form)) {
            return;
        }

        if (this.folderId) {
            const note: FolderNoteCreateInput = {
                folderId: this.folderId,
                note: this.form.value.note!,
            };

            const res = await this.store.api.createFolderNote(note);
            const id = res.id;

            this.wysiwyg()?.resetBackupValues();

            // Call the onSave callback if provided
            const onSave = this.dialogConfig.data?.onSave;
            if (onSave) {
                onSave({ ...note, id });
            }
        }

        this.dialogRef.close(this.form.value.note);
    }

}
